import React from 'react';
import { Checkbox } from '@material-ui/core';
import { MakeCellChildren } from '../../routes/components/MakeCell';

export const CheckBox = ({ validateCheck, onChange, directionLabel, label = '' }: { validateCheck: boolean; onChange: () => void; directionLabel?: 'row' | 'row-reverse'; label?: string }) => (
  <MakeCellChildren label={label} directionLabel={directionLabel}>
    <Checkbox checked={validateCheck} onChange={onChange} inputProps={{ 'aria-labelledby': 'transfer-list-item-all-label' }} color="primary" />
  </MakeCellChildren>
);
